/* JUST PC's upgrade options (replaces Easify). Vanilla JS, no dependencies.
 * 1. Product page: live total for the upgrade selector rendered by snippets/jp-upgrades.liquid.
 * 2. Add to cart: when upgrades are selected, the theme's single POST /cart/add is turned into ONE atomic
 *    POST /cart/add.js {items:[...upgrade children, parent]} (children first so the machine lists above them). Same response shape (items + sections), so the
 *    theme's own cart drawer / cart page refresh keeps working.
 * 3. Cart: quantity change / removal of an upgraded machine goes out as one /cart/update.js that also updates its
 *    upgrade lines (qty = parent qty x units).
 * 4. Reconcile on page load, and after every add/update: removes orphaned upgrade lines and resyncs quantities
 *    when Shopify caps a machine to its stock (upgrade variants are untracked).
 * Line item properties: parent {"Upgrade": "<labels>", "_upg": "<group>"}, child {"_upg_for": "<group>", "_upg_units": "<n>"}.
 * Prices always come from the upgrade variants, never from the client.
 */
(function () {
  'use strict';
  if (window.JPUpg) return;

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  }

  /* Upgrade lines are untracked, machines are not: Shopify can cap a machine to its stock while its upgrades
     keep the requested qty. Returns {lineKey: wantedQty} for every upgrade line out of step (0 = orphan). */
  function qtyFixes(cart) {
    var parents = {}, updates = {}, changed = false;
    cart.items.forEach(function (it) {
      var p = it.properties;
      if (p && p._upg && !p._upg_for) parents[p._upg] = it;
    });
    cart.items.forEach(function (it) {
      var p = it.properties;
      if (!p || !p._upg_for) return;
      var par = parents[p._upg_for];
      var want = par ? par.quantity * (parseInt(p._upg_units, 10) || 1) : 0;
      if (it.quantity !== want) { updates[it.key] = want; changed = true; }
    });
    return changed ? updates : null;
  }

  /* After an add/update: if the machine was capped, bring its upgrade lines in line in the same round trip,
     keeping the response shape the theme expects (add: items + sections; update: cart + sections). */
  function syncAfter(res, reqBody, isAdd) {
    if (!res) return res;
    return origFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = qtyFixes(cart);
        if (!updates) return res;
        if (!res.ok) {
          /* e.g. 422 "Only 1 item was added ... due to availability": Shopify still added the lines.
             Fix the upgrade qty, refresh the drawer, and pass the theme its own error message unchanged. */
          return origFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify({ updates: updates }) })
            .then(function () { refreshUi(); return res; });
        }
        var payload = { updates: updates };
        if (reqBody.sections) payload.sections = reqBody.sections;
        if (reqBody.sections_url) payload.sections_url = reqBody.sections_url;
        return origFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify(payload) })
          .then(function (r2) {
            if (!isAdd || !r2.ok) return r2;
            return Promise.all([res.json(), r2.json()]).then(function (a) {
              var d = a[0], u = a[1];
              if (u.sections) d.sections = u.sections;
              (d.items || []).forEach(function (i) { if (updates[i.key] !== undefined) i.quantity = updates[i.key]; });
              return new Response(JSON.stringify(d), { status: 200, headers: { 'Content-Type': 'application/json' } });
            });
          });
      })
      .catch(function (e) { console.error('[jp-upgrades] qty sync failed', e); return res; });
  }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = (window.Maximize && window.Maximize.currencyFormat) || 'R{{amount_no_decimals}}';
    var n = cents / 100;
    var whole = Math.round(cents) % 100 === 0;
    function render(dec, thousands, decimal) {
      var parts = n.toFixed(whole ? 0 : dec).split('.');
      var out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      if (parts[1]) out += decimal + parts[1];
      return out;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      if (name.indexOf('comma_separator') !== -1) return render(2, '.', ',');
      if (name.indexOf('space_separator') !== -1) return render(2, ' ', ',');
      if (name.indexOf('apostrophe_separator') !== -1) return render(2, "'", '.');
      return render(2, ',', '.');
    });
  }

  /* ---------- product page selector ---------- */
  function selectedInputs(c) {
    var out = [];
    var inputs = c.querySelectorAll('input.jp-upg__input:checked');
    for (var i = 0; i < inputs.length; i++) { if (inputs[i].dataset.code) out.push(inputs[i]); }
    return out;
  }

  function qtyFor(c) {
    var q = null;
    var formId = c.dataset.formId;
    if (formId) q = document.querySelector('input[name="quantity"][form="' + formId + '"]');
    if (!q) {
      var scope = c.closest('product-info') || c.closest('form') || document;
      q = scope.querySelector('input[name="quantity"]');
    }
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function updateTotal(c) {
    var out = c.querySelector('[data-jp-total]');
    if (!out) return;
    var sel = selectedInputs(c);
    if (!sel.length) { out.hidden = true; out.textContent = ''; return; }
    var unit = parseInt(c.dataset.basePrice, 10) || 0;
    for (var i = 0; i < sel.length; i++) {
      unit += (parseInt(sel[i].dataset.unitPrice, 10) || 0) * (parseInt(sel[i].dataset.mult, 10) || 1);
    }
    var qty = qtyFor(c);
    var txt = 'Total with upgrades: ' + formatMoney(unit * qty);
    if (qty > 1) txt += ' (' + qty + ' × ' + formatMoney(unit) + ')';
    out.textContent = txt;
    out.hidden = false;
  }

  function initContainer(c) {
    if (c.__jpInit) return;
    c.__jpInit = true;
    var sectionId = c.dataset.sectionId;
    if (sectionId) {
      document.addEventListener((typeof PRODUCT_EVENT !== 'undefined' ? PRODUCT_EVENT.updatedVariant : 'maximize:variant-picker:updated:') + sectionId, function (ev) {
        var v = ev && ev.detail && ev.detail.currentVariant;
        if (!v) return;
        c.dataset.basePrice = String(v.price);
        c.hidden = v.available === false;
        updateTotal(c);
      });
    }
    updateTotal(c);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-jp-upg]');
    for (var i = 0; i < list.length; i++) initContainer(list[i]);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var c = t.closest('[data-jp-upg]');
    if (c) { updateTotal(c); return; }
    if (t.name === 'quantity') {
      var all = document.querySelectorAll('[data-jp-upg]');
      for (var i = 0; i < all.length; i++) updateTotal(all[i]);
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.name === 'quantity') {
      var all = document.querySelectorAll('[data-jp-upg]');
      for (var i = 0; i < all.length; i++) updateTotal(all[i]);
    }
  });
  document.addEventListener('click', function (e) {
    /* quantity +/- buttons change the input programmatically; re-read shortly after */
    if (e.target && e.target.closest && e.target.closest('[name="plus"],[name="minus"],.quantity-input__button,[data-action="plus-qty"],[data-action="minus-qty"]')) {
      setTimeout(function () {
        var all = document.querySelectorAll('[data-jp-upg]');
        for (var i = 0; i < all.length; i++) updateTotal(all[i]);
      }, 60);
    }
  });

  function findContainer(variantId) {
    var all = document.querySelectorAll('[data-jp-upg]');
    var hit = null;
    for (var i = 0; i < all.length; i++) {
      var ids = (all[i].dataset.variantIds || '').split(',');
      if (ids.indexOf(String(variantId)) !== -1) {
        if (!hit || all[i].offsetParent !== null) hit = all[i];
      }
    }
    return hit;
  }

  /* ---------- add to cart ---------- */
  function handleAdd(input, init) {
    var fd = init.body;
    var id = fd.get('id');
    if (!id) return null;
    var c = findContainer(id);
    if (!c || c.hidden) return null;
    var sel = selectedInputs(c);
    if (!sel.length) return null;

    var qty = parseInt(fd.get('quantity'), 10);
    if (!(qty > 0)) qty = 1;

    var props = {};
    fd.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && typeof value === 'string') props[m[1]] = value;
    });

    var codes = [], labels = [];
    for (var i = 0; i < sel.length; i++) { codes.push(sel[i].dataset.code); labels.push(sel[i].dataset.label); }
    codes.sort();
    var group = String(id) + '-' + codes.join('.');
    var units = parseInt(c.dataset.units, 10) || 1;
    props['Upgrade'] = labels.join('; ') + (units > 1 ? ' (x' + units + ' machines)' : '');
    props['_upg'] = group;

    var parent = { id: Number(id), quantity: qty, properties: props };
    var sp = fd.get('selling_plan');
    if (sp) parent.selling_plan = Number(sp);
    /* children first: Shopify lists the last-added line on top, so the machine ends up above its upgrades */
    var items = [];
    for (var j = 0; j < sel.length; j++) {
      var mult = parseInt(sel[j].dataset.mult, 10) || 1;
      items.push({
        id: Number(sel[j].dataset.variantId),
        quantity: qty * mult,
        properties: { '_upg_for': group, '_upg_units': String(mult) }
      });
    }
    items.push(parent);

    var body = { items: items };
    var sections = fd.get('sections');
    if (sections) body.sections = String(sections);
    var su = fd.get('sections_url');
    if (su) body.sections_url = String(su);

    return origFetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify(body) })
      .then(function (res) { return syncAfter(res, body, true); });
  }

  /* ---------- cart quantity / remove ---------- */
  function handleChange(url, init) {
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return null; }
    if (!body || body.line === undefined || body.quantity === undefined || body.properties || body.id) return null;
    var q = parseInt(body.quantity, 10);
    if (isNaN(q) || q < 0) return null;
    var idx = parseInt(body.line, 10) - 1;
    return origFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = cart.items[idx];
        var p = it && it.properties;
        if (!p || !p._upg || p._upg_for) return origFetch(url, init);
        var updates = {};
        updates[it.key] = q;
        cart.items.forEach(function (c) {
          if (c.properties && c.properties._upg_for === p._upg) {
            var u = parseInt(c.properties._upg_units, 10) || 1;
            updates[c.key] = q * u;
          }
        });
        var payload = { updates: updates };
        if (body.sections) payload.sections = body.sections;
        if (body.sections_url) payload.sections_url = body.sections_url;
        return origFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify(payload) })
          .then(function (res) { return syncAfter(res, payload, false); });
      })
      .catch(function (err) {
        console.error('[jp-upgrades] change failed, falling back', err);
        return origFetch(url, init);
      });
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && init && init.body) {
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && typeof FormData !== 'undefined' && init.body instanceof FormData) {
          var p = handleAdd(input, init);
          if (p) return p;
        } else if (/\/cart\/change(\.js)?(\?|$)/.test(url) && typeof init.body === 'string') {
          var p2 = handleChange(url, init);
          if (p2) return p2;
        }
      }
    } catch (e) {
      console.error('[jp-upgrades] intercept error', e);
    }
    return origFetch(input, init);
  };

  /* ---------- reconcile orphans ---------- */
  function refreshUi() {
    if (window.Maximize && window.Maximize.isCartPage) { window.location.reload(); return; }
    var drawer = document.querySelector('#CartDrawer');
    var sid = drawer && drawer.dataset.sectionId;
    if (!sid || !window.xCartHelper || typeof window.getSectionInnerHTML !== 'function') return;
    var toRender = window.xCartHelper.getSectionsToRender(sid);
    var ids = toRender.map(function (s) { return s.id; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    origFetch(root + '?sections=' + encodeURIComponent(ids.join(',')), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        toRender.forEach(function (s) {
          var el = document.querySelector(s.selector);
          if (el && data[s.id]) el.innerHTML = window.getSectionInnerHTML(data[s.id], s.selector);
        });
        if (window.xCartHelper.updateCurrentCountItem) window.xCartHelper.updateCurrentCountItem();
      })
      .catch(function (e) { console.error('[jp-upgrades] refresh failed', e); });
  }

  var reconciling = false;
  function reconcile() {
    if (reconciling) return;
    if (!/(^|;\s*)cart=/.test(document.cookie) && !(window.Maximize && window.Maximize.isCartPage)) return;
    reconciling = true;
    origFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = qtyFixes(cart);
        if (!updates) return null;
        return origFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify({ updates: updates }) })
          .then(function () { refreshUi(); });
      })
      .catch(function (e) { console.error('[jp-upgrades] reconcile failed', e); })
      .then(function () { reconciling = false; });
  }

  function boot() {
    initAll(document);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType === 1 && (n.matches && n.matches('[data-jp-upg]') || n.querySelector && n.querySelector('[data-jp-upg]'))) { initAll(n.parentNode || document); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcile(); });

  window.JPUpg = { reconcile: reconcile, formatMoney: formatMoney };
})();
